import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-question-nps",
  "use": "foquz-icon-question-nps-usage",
  "viewBox": "0 0 26 16",
  "content": "<symbol viewBox=\"0 0 26 16\" fill=\"none\" id=\"foquz-icon-question-nps\"><path d=\"M19.543 10.704A6 6 0 0120 13h5a12 12 0 00-24 0h5a6 6 0 01.457-2.296c.301-.728.806-1.647 1.363-2.204a7.303 7.303 0 012.15-1.438m4.828 6.67c-.496 1.064-1.71 1.547-2.71 1.08-1.002-.466-1.411-1.707-.916-2.77.496-1.064 5.404-6.857 5.404-6.857s-1.282 7.484-1.778 8.547z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol